import style from "./appModePage.module.scss";
import AccountHeader from "../../components/AppAccount/AccountHeader";
import FavouritesTabGroup from "../favourites/FavouritesTabGroup";

const FavouritesPage = () => {
  return (
    <div className={style.favouriteAccountContainer}>
      <div className={style.mobileOnly}>
        <AccountHeader headername="My favourites" />
      </div>
      <FavouritesTabGroup />
    </div>
  );
};

export default FavouritesPage;
